import React from 'react';
import './SkeletonCard.scss';

const SkeletonCard = ({ width = '100%', height = '160px', style = {} }) => (
  <div
    className="skeleton-card"
    style={{ width, height, ...style }}
    aria-busy="true"
    aria-label="Loading card"
  />
);

export default SkeletonCard;
